import * as React from 'react'
import './Tabs.scss'

const Tabs = ({className = "", ...props}) => <div {...props} className={`Tabs ${className}`}/>

export default Tabs